import { getEnvironment } from "../src/Util/Utils";

export const msalConfig = {
  auth: {
    clientId:
      getEnvironment() === "prod" ? "b4b48e64-6cdd-452a-ba2a-34bdeacfe294" : "a77961a6-5a22-4701-87e8-31e03ad7ca56",
    authority: "https://login.microsoftonline.com/3b214a92-dd33-4a9c-a070-43f6783d144c",
    redirectUri:
      window.location.host === "localhost:3000" ? "http://localhost:3000/" : `${window.location.origin}/redirect`,
  },
};
